import styled from 'styled-components'

export const home = styled.main`
`